export const storage_keys = {
  api_last_team_id: 'api:last_team_id',
  degraded_banner_dismissed_at: 'dashboard:degraded_banner_dismissed_at',
  show_get_started: 'dashboard:show_get_started',
  hide_member_trial_modal: 'dashboard:hide_member_trial_modal',
  session: {
    dashboard_session: 'dashboard:session',
  },
};
